import React, { createContext, useContext, useState, useEffect } from 'react';
import api, { DB_TYPE } from '../api';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (DB_TYPE === 'firebase') {
      const unsub = onAuthStateChanged(auth, async (fbUser) => {
        if (fbUser) {
          const docSnap = await getDoc(doc(db, 'users', fbUser.uid));
          if (docSnap.exists()) {
            setUser({ id: fbUser.uid, ...docSnap.data() });
          } else {
            setUser({ id: fbUser.uid, email: fbUser.email });
          }
        } else {
          setUser(null);
        }
        setLoading(false);
      });
      return unsub;
    } else {
      const token = localStorage.getItem('sas_token');
      if (token) {
        api.get('/auth/me')
          .then(r => setUser(r.data))
          .catch(() => localStorage.removeItem('sas_token'))
          .finally(() => setLoading(false));
      } else setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    if (password === 'password123') { // TEMPORARY - For seeded users
        const q = query(collection(db, "users"), where("email", "==", email));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
            const userDoc = querySnapshot.docs[0];
            const userData = { id: userDoc.id, ...userDoc.data() };
            setUser(userData);
            // This is a mock sign-in, it won't persist across reloads
            // We are setting the user state directly.
            return userData;
        }
    }

    // Regular Firebase Auth login
    const { user: fbUser } = await signInWithEmailAndPassword(auth, email, password);
    const docSnap = await getDoc(doc(db, 'users', fbUser.uid));
    if (docSnap.exists()) {
        const userData = { id: fbUser.uid, ...docSnap.data() };
        setUser(userData);
        return userData;
    } else {
        throw new Error("User data not found in Firestore.");
    }
  };

  const logout = async () => {
    if (DB_TYPE === 'firebase') {
      await signOut(auth);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
